module.exports = __webpack_public_path__ + "img/storj.e7581753.svg";